import styled from 'styled-components';
import { rem } from '../../utils';
export const StyledWrapper = styled.div `
  display: flex;
  flex-direction: column;
  width: 100%;

  flex-wrap: wrap;
  gap: ${({ theme }) => rem(theme.Spacing.Size.XXSmall)};
`;
export const StyledListWrapper = styled.div `
  display: flex;
  align-items: flex-start;
  align-content: flex-start;
  justify-content: flex-start;
  width: 100%;
  overflow: hidden;
  flex-wrap: wrap;
  gap: ${({ theme }) => rem(theme.Spacing.Size.XSmall)};
`;
export const StyledPaletteLabel = styled.div `
  display: flex;
  width: 100%;
  gap: ${({ theme }) => rem(theme.Spacing.Size.XSmall)};
`;
//# sourceMappingURL=ColorGrid.style.js.map